import FormInputTypes from '../components/atoms/formEnums/formInputTypes';


export default {
  title: 'Viewport Prediction configuration',
  attributeName: 'viewportPrediction',
  fields: [
    {
      attributeName: 'viewportPredictionTime',
      helpText: 'How far in advance will the client go for estimating a future viewport position (milliseconds).',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Viewport Prediction Time',
      placeholder: 'Input a viewport prediction time...',
      default: 0,
    },
    {
      attributeName: 'angularVelocityDatapoints',
      helpText: 'How many recent data points to consider for performing a weighted average of the angular velocity, for prediction purposes.',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Angular Velocity Datapoints',
      placeholder: 'Input an angular velocity datapoints...',
      default: 0,
    },
    {
      attributeName: 'angularVelocityAttenuationFactor',
      helpText: 'The attenuation factor to use when assigning weights in the weighted average of the angular velocity, for prediction purposes, this factor is used subsequently for all data points into consideration (<=1.0).',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Angular Velocity Attenuation Factor',
      placeholder: 'Input an angular velocity attenuation factor...',
      default: 0,
    },
  ],
};
